import TOKEN from '../TOKEN';
import Node from './Node';

export default class List extends Node {
  constructor(items) {
    super();
    const [{ bullet: { type, index } = {} } = {}] = items;
    this.type = type === TOKEN.ORDERED_ITEM ? TOKEN.ORDERED_LIST : TOKEN.UNORDERED_LIST;
    this.index = index;
    this.items = items;
  }

  finalize(root, parent) {
    super.finalize(root, parent);
    this.items.forEach((item) => item.finalize(root, this));
    this.root.emojiOnly = false;
  }

  toJSON() {
    return {
      type: this.type,
      index: this.index,
      items: this.items.map((i) => i.toJSON()),
    };
  }

  toSource() {
    return this.items.map((i) => i.toSource()).join('');
  }
}
